module.exports = __webpack_public_path__ + "src/assets/games/13/85.jpg";